<template>
  <div class="banner limit-px" :style="{'background-image': `url(${websiteConfig.articleBanner})`}">
    <slot></slot>
  </div>
</template>

<script lang="ts" setup>
import websiteConfig from "@/configs/websiteConfig";
</script>
